import React from 'react';
import BadgeIcon from '../../../assets/icons/svg/Badge';

const BadgeSizes = {
  small: 'size-48 cw-badge--small',
  large: 'size-80 cw-badge--large'
} as const;

export type BannerProps = {
  text: string;
  backgroundColor: string;
  fontColor: string;
}

type BadgeProps = BannerProps & {
  size?: keyof typeof BadgeSizes;
  className?: string;
}

export const Badge = ({ text, backgroundColor, fontColor, size = 'large', className = '' }: BadgeProps) => {
  const svgWithProps = React.cloneElement(<BadgeIcon />, {
    className: 'w-full h-full box-border',
    style: { fill: backgroundColor }
  });

  const Badge: React.ElementType = 'span';

  return (
    <Badge className={`z-40 pointer-events-none absolute inline-block text-center box-content spect-square cw-badge ${BadgeSizes[size]} ${className}`}>
      <p className='absolute w-full m-0 break-words uppercase -rotate-45 font-extrabold' style={{ WebkitLineClamp: 1, color: fontColor }}>{text}</p>
      {svgWithProps}
    </Badge >
  );
};
